import RenderedModuleModel from 'EmailEditorUI/data/models/RenderedModuleModel';
import { PRIMITIVE_JS_VALUE, JS_OBJECT, ALLOWLISTED_AUTH_OBJECT, NestedJsObject
// @ts-expect-error module not migrated yet
} from 'ContentEditorUI/redux/inpageSync/types';
export default {
  appStatus: JS_OBJECT,
  auth: ALLOWLISTED_AUTH_OBJECT,
  brandSettings: JS_OBJECT,
  contentReadOnlyData: JS_OBJECT,
  customObjectIds: JS_OBJECT,
  ecomm: JS_OBJECT,
  emailCategories: JS_OBJECT,
  feedback: JS_OBJECT,
  languages: JS_OBJECT,
  moduleSchemas: JS_OBJECT,
  contentAssistant: JS_OBJECT,
  onboardingStatus: NestedJsObject({
    currentOnboarding: PRIMITIVE_JS_VALUE,
    currentStep: PRIMITIVE_JS_VALUE,
    steps: JS_OBJECT,
    dismissed: PRIMITIVE_JS_VALUE,
    completed: PRIMITIVE_JS_VALUE,
    isStartedFromActions: PRIMITIVE_JS_VALUE,
    showOnboardingDismiss: PRIMITIVE_JS_VALUE,
    isOnboardingTourInProgress: PRIMITIVE_JS_VALUE
  }),
  panesVisitStatus: JS_OBJECT,
  portalDomains: JS_OBJECT,
  portal: JS_OBJECT,
  renderedModules: {
    immutable: false,
    parseAfterMessageReceived: valueToImport => {
      return Object.keys(valueToImport).reduce((obj, id) => {
        obj[id] = new RenderedModuleModel(valueToImport[id]);
        return obj;
      }, {});
    }
  },
  modals: {
    immutable: false,
    exportBeforeMessageSent: valueToExport => ({
      openModal: valueToExport.openModal
    })
  },
  requestStates: JS_OBJECT,
  saveData: JS_OBJECT,
  selected: {
    immutable: false,
    nestedConfig: {
      showErrorsImmediately: PRIMITIVE_JS_VALUE,
      fieldPath: PRIMITIVE_JS_VALUE,
      selectedId: PRIMITIVE_JS_VALUE,
      highlightedElementId: PRIMITIVE_JS_VALUE,
      forcedHighlightedElementId: PRIMITIVE_JS_VALUE,
      selectedByApp: PRIMITIVE_JS_VALUE,
      currentTab: PRIMITIVE_JS_VALUE,
      addPanelTab: PRIMITIVE_JS_VALUE,
      selectedType: PRIMITIVE_JS_VALUE,
      sidebarOpen: PRIMITIVE_JS_VALUE,
      modulesSearchTerm: PRIMITIVE_JS_VALUE
    }
  },
  siteSettings: JS_OBJECT,
  styleBreakpoints: JS_OBJECT,
  testFlags: JS_OBJECT,
  userAttributes: JS_OBJECT,
  hubSettings: JS_OBJECT,
  /*
    To keep the commentable areas and indicators updated
    properly we will be passing the main sidebar state down to them.
    This tells us which commentable areas have comments and if comment mode is active.
  */
  collaborationSidebar: JS_OBJECT,
  darkMode: JS_OBJECT,
  paneState: JS_OBJECT,
  emailValidation: JS_OBJECT
};